import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    clearButton: 'Clear the input',
    errors: {
      min: 'Please enter at least two characters',
      siretInvalid: 'This SIREN or SIRET seems invalid',
    },
    goCapitalDeposit: 'I want to deposit my capital',
    inputPlaceholder: 'Name of the company, or SIREN / SIRET',
    searchButton: 'Search',
    title: 'Find your company',
  },

  fr: {
    clearButton: 'Vider le champ de recherche',
    errors: {
      min: 'Veuillez entrer au minimum deux caractères',
      siretInvalid: 'Ce SIREN ou SIRET semble invalide',
    },
    goCapitalDeposit: 'Je souhaite déposer mon capital',
    inputPlaceholder: 'Nom de l’entreprise ou SIRET/SIREN',
    searchButton: 'Rechercher',
    title: 'Recherchez votre entreprise',
  },
} as const);
